// extracted by mini-css-extract-plugin
export var activeDot = "_5z-c";
export var buttonContainer = "_5z-9";
export var channelButton = "_5z-a";
export var content = "_5z-0";
export var contentFull = "_5z-2";
export var contentThird = "_5z-1";
export var contentWrapper = "_5z-7";
export var description = "_5z-5";
export var heightShort = "_5z-e";
export var image = "_5z-3";
export var imageContainer = "_5z-4";
export var selectButton = "_5z-d";
export var spinnerContainer = "_5z-b";
export var titleContent = "_5z-8";
export var titleWrapper = "_5z-6";